import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import HeaderSignInButton from 'features/feature_home/components/HeaderSignInButton';
import LanguageDropdown from 'core/components/LanguageDropdown';
import { useTranslation } from 'core/context/TranslationContext';
import 'core/styles/public.css';

const NAV = [
  { to: '/jobs', label: 'Browse Jobs' },
  { to: '/employers', label: 'Employers' },
  { to: '/candidates', label: 'Candidates' },
  { to: '/cv', label: 'CV Builder' }
];

function Header() {
  const { _t } = useTranslation();
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  const linkClass = ({ isActive }) => (isActive ? 'is-active' : undefined);

  return (
    <header className={`jf-public jf-header${scrolled ? ' is-scrolled' : ''}`}>
      <div className="jf-container jf-header__inner">
        <div className="jf-header__left">
          <Link to="/" className="jf-logo" aria-label="Job Flow Connect">
            <img alt="Job Flow Connect" src="/assets/images/jlogo.png" />
          </Link>
          <nav className="jf-nav" aria-label="Main">
            {NAV.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass}>
                {_t(item.label)}
              </NavLink>
            ))}
          </nav>
        </div>

        <div className="jf-header__right">
          <LanguageDropdown />
          <HeaderSignInButton />
          <button
            type="button"
            className="jf-burger"
            aria-label="Open menu"
            aria-expanded={open}
            onClick={() => setOpen(true)}
          >
            <Menu size={20} />
          </button>
        </div>
      </div>

      {open && createPortal(
        <div className="jf-public">
          <div className="jf-drawer-backdrop" onClick={() => setOpen(false)} />
          <aside className="jf-drawer" role="dialog" aria-modal="true" aria-label="Menu">
            <div className="jf-drawer__head">
              <img alt="Job Flow Connect" src="/assets/images/jlogo.png" style={{ height: 30 }} />
              <button type="button" className="jf-burger" style={{ display: 'inline-flex' }} aria-label="Close menu" onClick={() => setOpen(false)}>
                <X size={20} />
              </button>
            </div>
            <NavLink to="/" end className={({ isActive }) => `jf-drawer__link${isActive ? ' is-active' : ''}`}>
              {_t('Home')}
            </NavLink>
            {NAV.map((item) => (
              <NavLink key={item.to} to={item.to} className={({ isActive }) => `jf-drawer__link${isActive ? ' is-active' : ''}`}>
                {_t(item.label)}
              </NavLink>
            ))}
          </aside>
        </div>,
        document.body
      )}
    </header>
  );
}

export default Header;
